module.exports = __webpack_public_path__ + "img/idp.d3d54dd9.jpg";